import { useRollbar } from '@rollbar/react'
import { useEffect } from 'react'
import { useRouteError } from 'react-router'
import ErrorBoundaryUI from './ErrorBoundaryUI'

const AppRoutesErrorElement: React.FC = () => {
  const error = useRouteError()
  const rollbar = useRollbar()
  useEffect(() => {
    // If there is a route error, log it to Rollbar
    if (error) rollbar.error(error)
  }, [error, rollbar])

  // Render ErrorBoundaryUI instead of the default 'Unexpected Application Error'
  return <ErrorBoundaryUI error={error as Error} resetError={() => window.location.reload()} />
}

export default AppRoutesErrorElement
